export default {
  filter_list: [
    {
      filter: {},
      sort: null,
      page: 1,
    },
  ],
  sorting_dropdown_list_product: {
    'rating+': {
      name: 'MAIS BEM AVALIADOS',
      value: 'rating+',
      sort_field: 'rating',
      sort_direction: 'desc',
    },
    newest: {
      name: 'ÚLTIMOS LANÇAMENTOS',
      value: 'newest',
      sort_field: 'prodAddDate',
      sort_direction: 'desc',
    },
    'a-z': {
      name: 'NOME DE A-Z',
      value: 'a-z',
      sort_field: 'productName',
      sort_direction: 'asc',
    },
    'z-a': {
      name: 'NOME DE Z-A',
      value: 'z-a',
      sort_field: 'productName',
      sort_direction: 'desc',
    },
  },
  sorting_dropdown_list_article: {
    'most-viewed': {
      name: 'NENHUM VENDEDOR ENCONTRADO',
      value: 'most-viewed',
      sort_field: 'GAPopularityCount',
      sort_direction: 'desc',
    },
    newest: {
      name: 'ÚLTIMOS LANÇAMENTOS',
      value: 'newest',
      sort_field: 'articleAddDate',
      sort_direction: 'desc',
    },
    'a-z': {
      name: 'NOME DE A-Z',
      value: 'a-z',
      sort_field: 'articleTitle',
      sort_direction: 'asc',
    },
    'z-a': {
      name: 'NOME DE Z-A',
      value: 'z-a',
      sort_field: 'articleTitle',
      sort_direction: 'desc',
    },
  },
};
